import ControlFactory from '@/Factories/ControlFactory';
import AssociationMultiAutocompleteBox from '@/Controls/AssociationMultiAutocompleteBox';
import AssociationMultiAutocompleteBoxViewModel from '@/ViewModels/Controls/AssociationMultiAutocompleteBoxViewModel';
import { IRefreshable } from '#/DefaultViewExtensionInterfaces';
import AssociationMultiAutocompleteBoxViewModelT from '@/ViewModels/Controls/AssociationMultiAutocompleteBoxViewModel';
import MultiSelectAutoCompleteViewModelT from '@/ViewModels/Controls/MultiSelectAutoCompleteViewModel';
import LinkViewModelT from '@/ViewModels/Controls/LinkViewModel';
import ImageViewModelT from '@/ViewModels/Controls/ImageViewModel';
import SearchListViewViewModelT from '@/ViewModels/Views/SearchListViewViewModel';
import LabelViewModelT from '@/ViewModels/Controls/LabelViewModel';
import NavigationService from '@/Management/NavigationService';
import Config from '@/Management/GlobalConfiguration';
import ComponentManager from '@/Management/ComponentManager';
import RADEnvironmentProxy from '@/Communication/RADEnvironmentProxy';
import Loader from '@/Utility/Loader';
import FilterHelper from '@/Utility/FilterHelper';
import LocatorHelper from '@/Utility/LocatorHelper';
export default class AssociationMultiAutocompleteBoxFactory extends ControlFactory implements IRefreshable {
    /** @overrides */
    public control: AssociationMultiAutocompleteBox;
    /** @overrides */
    public viewModel: AssociationMultiAutocompleteBoxViewModel;
    private jQueryControl: JQuery;
    protected pdoId: () => any;
    public orderStatement: any;
    public containsMode: boolean;
    public maxSuggestions: number;
    public searchFields: string;
    public minLength: number;
    public defaultIterator: any;
    public dataIterator: any;
    public iterator: any;
    public isModalCreating: any;
    private AssociationMultiAutocompleteBoxViewModel: any;
    private AssociationMultiAutocompleteBox: any;
    private ObjectDisconnectionHelper: any;
    private MultiSelectAutoCompleteViewModel: any;
    protected LinkViewModel: any;
    protected ImageViewModel: any;
    private SearchListViewViewModel: any;
    protected LabelViewModel: any;
    private viewFactorySearchListView: any;
    private pdoIDsToHide: number[] = [];
    constructor(protected params: any) {
        super(params);
        this.jQueryControl = null;
        this.AssociationMultiAutocompleteBoxViewModel = ComponentManager.getViewModel<typeof AssociationMultiAutocompleteBoxViewModelT>('AssociationMultiAutocompleteBoxViewModel');
        this.AssociationMultiAutocompleteBox = ComponentManager.getControl('AssociationMultiAutocompleteBox');
        this.ObjectDisconnectionHelper = ComponentManager.getUtility('ObjectDisconnectionHelper');
        this.MultiSelectAutoCompleteViewModel = ComponentManager.getViewModel<typeof MultiSelectAutoCompleteViewModelT>('MultiSelectAutoCompleteViewModel');
        this.LinkViewModel = ComponentManager.getViewModel<typeof LinkViewModelT>('LinkViewModel');
        this.ImageViewModel = ComponentManager.getViewModel<typeof ImageViewModelT>('ImageViewModel');
        this.SearchListViewViewModel = ComponentManager.getViewModel<typeof SearchListViewViewModelT>('SearchListViewViewModel');
        this.LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModelT>('LabelViewModel');
        this.viewFactorySearchListView = null;
        this.defaultIterator = this.context.defaultIterators[this.detailViewItem.name];
        this.dataIterator = null;
        this.iterator = null;
        this.isModalCreating = this.paramOrDefault(params.isModalCreating, false);
        this.registerForMessageId('RefreshAssociationsMessage', () => {
            this.refresh();
        });
        this.dataBoundHandler = this.dataBoundHandler.bind(this);
    }
    /** @overrides */
    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }
        this.orderStatement = this.paramOrDefault(this.params.orderStatement, this.detailViewItem.listView.defaultOrder);
        this.containsMode = this.paramOrDefault(this.params.containsMode, true);
        this.maxSuggestions = this.paramOrDefault(this.params.maxSuggestions, 150);
        this.searchFields = this.paramOrDefault(this.params.searchFields, 'ObjectIdentValue');
        this.minLength = this.paramOrDefault(this.params.minLength, 1);
        let getIterator = () => {
            return RADEnvironmentProxy.getInstance().createIteratorForAssoziation({
                pdTypeName: this.context.genericObject.pdTypeName,
                pdo_id: this.context.genericObject.pdoId,
                assoziationName: this.detailViewItem.name,
                properties: ['ObjectIdentValue'],
                retrieveExtentCount: true,
                itOperator: {
                    includeAllPrincipals: this.detailViewItem.listView.includeAllPrincipals,
                    includeBasePrincipals: this.detailViewItem.listView.includeBasePrincipals,
                    includeSubPrincipals: this.detailViewItem.listView.includeSubPrincipals,
                    memoryOptimizationEnabled: true,
                    onlySubPrincipals: null,
                    historizationDates: null,
                    isGridIterator: null,
                    principalFilter: null,
                    searchObjectPositionRequest: null,
                    visibleDeletedObjects: null,
                    hideConnectedElementsRequest: null
                },
                filter: '',
                orderby: ''
            });
        }
        this.viewModel = (() => {
            let associationMultiAutocompleteBoxViewModel = new this.AssociationMultiAutocompleteBoxViewModel({
                parentLocator: this.locator,
                locator: this.detailViewItem.name,
                tooltip: new this.LabelViewModel({
                    ergName: this.detailViewItem.tooltip
                }),
                factory: this,
                isRequired: this.isRequired,
                isEnabled: this.isEnabled,
                isValid: this.isValid,
                isBusy: this.isBusy,
                multiSelectAutoComplete: new this.MultiSelectAutoCompleteViewModel({
                    parentLocator: this.locator,
                    locator: LocatorHelper.buildLocator(this.detailViewItem.name, 'autocomplete'),
                    containsMode: this.containsMode,
                    dataTextField: 'objectIdentValue',
                    dataValueField: 'pdoId',
                    isFocusable: this.isFocusable,
                    minLength: this.minLength,
                    dataBound: this.dataBoundHandler,
                    dataSource: (() => {
                        return new kendo.data.DataSource({
                            transport: {
                                read: (options) => {
                                    //Wenn die DV schnell verlassen wir, dann muss dies hier abgefangen werden
                                    if (!this || !this.viewModel || !this.viewModel.multiSelectAutoComplete) {
                                        return;
                                    }
                                    // otherwise request value-candidates from server
                                    let pdTypeName = this.detailViewItem.listView.typeName;
                                    // add a filter to the request, in case that any filter-input is given
                                    let filter = this.assembleFilter(options, pdTypeName);
                                    this.isBusy(true);
                                    this.deleteIterators([this.dataIterator]);
                                    RADEnvironmentProxy.getInstance().createIteratorWithOperator({
                                        pdTypeName: pdTypeName,
                                        properties: ['ObjectIdentValue'],
                                        filter: filter ? JSON.stringify(filter) : null,
                                        orderby: this.convertOrderStatementWithoutAssociation(this.orderStatement),
                                        retrieveExtentCount: true,
                                        contextPDO_ID: this.context.genericObject.pdoId,
                                        itOperator: {
                                            includeAllPrincipals: this.detailViewItem.listView.includeAllPrincipals,
                                            includeBasePrincipals: this.detailViewItem.listView.includeBasePrincipals,
                                            includeSubPrincipals: this.detailViewItem.listView.includeSubPrincipals,
                                            memoryOptimizationEnabled: true,
                                            onlySubPrincipals: null,
                                            historizationDates: null,
                                            isGridIterator: null,
                                            principalFilter: null,
                                            searchObjectPositionRequest: null,
                                            visibleDeletedObjects: null,
                                            hideConnectedElementsRequest: null
                                        }
                                    }).then((iterator) => {
                                        if (this.isDisposed)
                                            return null;
                                        
                                        this.dataIterator = iterator;
                                        if (this.isDisposed || +iterator.extentCount <= 0) {
                                            return null;
                                        }
                                        return RADEnvironmentProxy.getInstance().getExtentWithPDOIDAsFirstColumn({
                                            iteratorID: iterator.id,
                                            start: 0,
                                            end: Math.min(+iterator.extentCount - 1, this.maxSuggestions - 1)
                                        });
                                    }).then((arrayOfGeneric) => {
                                        if (this.isDisposed) {
                                            return;
                                        }
                                        let result = [];
                                        if (arrayOfGeneric) {
                                            for (let i = 0; i < arrayOfGeneric.length; i++) {
                                                result.push({
                                                    pdoId: arrayOfGeneric[i][0],
                                                    objectIdentValue: arrayOfGeneric[i][1]
                                                });
                                            }
                                        }
                                        // sync data and values
                                        // here: add selected values that are not present in data anymore
                                        //Die Elemente, die das Control vom Server erh�lt, sind in jedem Fall korrekt.
                                        //Kendo ben�tigt jedoch, dass die ausgew�hlten Elemente auch im Dropdown - Men� verbleiben, 
                                        //damit sie korrekt im Eingabefeld angezeigt werden.Zum Beispiel kann es bei einem statischen Filter die Bedingung geben, 
                                        //dass die ausgew�hlten Elemente nicht im Dropdown - Men� enthalten sein sollen. Daher werden hier values und data synchronisiert.
                                        result = this.addValuesToDataIfNotPresent(this.viewModel.multiSelectAutoComplete.values(), result, true);
                                        options.success(result);
                                    }).always(() => {
                                        if (!this.isDisposed) {
                                            this.isBusy(false);
                                        }
                                    });
                                }
                            },
                            serverFiltering: true,
                            serverSorting: true
                        });
                    })(),
                    values: this.defineAsyncComputed((): any => {
                        this.deleteIterators([this.iterator]);
                        return $.when(getIterator()).then((iterator) => {
                            if (this.isDisposed)
                                return null;
                            
                            this.iterator = iterator;
                            if (this.iterator.extentCount > 0) {
                                return RADEnvironmentProxy.getInstance().getExtentWithPDOIDAsFirstColumn({
                                    iteratorID: this.iterator.id,
                                    start: 0,
                                    end: this.iterator.extentCount - 1
                                });
                            }
                            return undefined;
                        }).then((arrayOfGeneric) => {
                            if (this.isDisposed || arrayOfGeneric == null)
                                return undefined;

                            let result = [];
                            for (let i = 0; i < arrayOfGeneric.length; i++) {
                                result.push({
                                    pdoId: arrayOfGeneric[i][0],
                                    objectIdentValue: arrayOfGeneric[i][1]
                                });
                            }
                            // sync data and values
                            let newData = this.addValuesToDataIfNotPresent(result, this.viewModel.multiSelectAutoComplete.dataSource.data());
                            this.viewModel.multiSelectAutoComplete.dataSource.data(newData);
                            return result;
                        });
                    }, []),
                    onConnect: (toPDOID) => {
                        this.OnConnection([toPDOID]);
                    },
                    onDisconnect: (toPDOID) => {
                        this.OnDisconnection(toPDOID);
                    },
                    onOpen: () => {
                        if (this.detailViewItem.listView.staticFilterExpression != '')
                            this.viewModel.multiSelectAutoComplete.dataSource.read();
                    },
                    isEnabled: this.isEnabled,
                    isValid: this.isValid,
                    invalidationText: this.invalidationText
                }),
                linkCreate: new this.LinkViewModel({
                    parentLocator: this.locator,
                    locator: LocatorHelper.buildLocator(this.detailViewItem.name, 'link.create'),
                    tooltip: new this.LabelViewModel({
                        ergName: 'CREATE_NEW_AND_CONNECT_TOOLTIP'
                    }),
                    image: new this.ImageViewModel({
                        parentLocator: this.locator,
                        locator: LocatorHelper.buildLocator(this.detailViewItem.name, 'link.create.image'),
                        source: Config.inlineImages.OBJ_CREATE,
                        alternativeText: new this.LabelViewModel({
                            ergName: 'CREATE_NEW_AND_CONNECT_TOOLTIP'
                        })
                    }),
                    onClick: () => {
                        let associationName = this.detailViewItem.listView.relationName;
                        $.when(this.context.notifyBeforeUpdatedAssociation(associationName, 'connect', { toPdoIds: [null] }))
                            .then((doUpdateAssociation) => {
                                if (this.isDisposed)
                                    return;
                                
                                if (doUpdateAssociation == null || doUpdateAssociation === true) {
                                    this.context.createContext(this, this.detailViewItem.listView, null, null, null, null, this.isModalCreating);
                                }
                            });
                    },
                    isFocusable: this.isFocusable,
                    isVisible: this.defineComputed(() => {
                        return this.isEnabled() && this.detailViewItem.listView.showButtonCreate;
                    }),
                    isToolBarLink: true,
                    isEnabled: this.isEnabled
                }),
                linkSelect: new this.LinkViewModel({
                    parentLocator: this.locator,
                    locator: LocatorHelper.buildLocator(this.detailViewItem.name, 'link.select'),
                    tooltip: new this.LabelViewModel({
                        ergName: 'FIND_AND_CONNECT_TOOLTIP'
                    }),
                    image: new this.ImageViewModel({
                        parentLocator: this.locator,
                        locator: LocatorHelper.buildLocator(this.detailViewItem.name, 'link.select.image'),
                        source: Config.inlineImages.OBJ_SELECT,
                        alternativeText: new this.LabelViewModel({
                            ergName: 'FIND_AND_CONNECT_TOOLTIP'
                        })
                    }),
                    isFocusable: this.isFocusable,
                    onClick: () => {
                        if (this.viewFactorySearchListView != null) {
                            return;
                        }
                        this.viewFactorySearchListView = NavigationService.getInstance().loadViewFactoryIsolated('SearchListView', {
                            viewModel: new this.SearchListViewViewModel({
                                parentLocator: this.locator,
                                locator: LocatorHelper.buildLocator(this.detailViewItem.name, 'selectview'),
                                listView: this.detailViewItem.listView,
                                allowMultiSelect: true,
                                contextPdoId: this.context.genericObject.pdoId,
                                callback: (toPDOIDs) => {
                                    if (toPDOIDs && toPDOIDs.length > 0) {
                                        this.OnConnection(toPDOIDs);
                                    }
                                },
                                onClose: () => {
                                    associationMultiAutocompleteBoxViewModel.linkSelect.hasFocus(true);
                                    NavigationService.getInstance().removeViewFactoryIsolated(this.viewFactorySearchListView);
                                    this.viewFactorySearchListView = null;
                                }
                            })
                        }, true);
                    },
                    isVisible: this.defineComputed(() => {
                        return this.isEnabled() && this.detailViewItem.listView.showButtonSelect;
                    }),
                    isToolBarLink: true,
                    isEnabled: this.isEnabled
                })
            });
            return associationMultiAutocompleteBoxViewModel;
        })();
        this.control = (() => {
            return new this.AssociationMultiAutocompleteBox(this.viewModel);
        })();
        let tuple = this.control.getTuple();
        this.jQueryControl = tuple.control;
        this.registerObservableValidation(this.viewModel.multiSelectAutoComplete.values);
        return this.jQueryControl;
    }
    public notifyDetailViewClosed(topdTypeName?: any, toPDOID?: any): void {
        this.viewModel.multiSelectAutoComplete.dataSource.read();
        let oldValues = this.viewModel.multiSelectAutoComplete.values();
        this.viewModel.multiSelectAutoComplete.values.evaluate().then((newValues) => {
            if (this.isDisposed)
                return;
            
            let pdoIdsNewValues = _.map(newValues, 'pdoId');
            let pdoIdsOldValues = _.map(oldValues, 'pdoId');
            if (pdoIdsOldValues.length != pdoIdsNewValues.length || _.difference(pdoIdsNewValues, pdoIdsOldValues).length > 0) {
                this.context.notifyUpdatedAssociation(this.detailViewItem.listView.relationName);
                this.context.notifyFactoryRefreshed(this.detailViewItem);
            }
        });
        this.viewModel.multiSelectAutoComplete.values.evaluate();
    }
    /** @overrides */
    protected disposeInternal(): void {
        this.deleteIterators([this.defaultIterator, this.dataIterator, this.iterator]);
        if (this.viewFactorySearchListView != null && !this.viewFactorySearchListView.isDisposed) {
            NavigationService.getInstance().removeViewFactory(this.viewFactorySearchListView);
        }
        super.disposeInternal();
    }
    /** @implements */
    public refresh(): void {
        this.viewModel.multiSelectAutoComplete.dataSource.read();
        this.viewModel.multiSelectAutoComplete.values.evaluate();
    }
    public deleteIterators(iterators: any): any {
        if (this.isDisposed || iterators == null) {
            return;
        }
        iterators = iterators.filter((it) => { return it != null; });
        if (iterators != null && iterators.length > 0) {
            RADEnvironmentProxy.getInstance().deleteIterators({
                iteratorIDs: iterators.map((it) => { return parseInt(it.id); })
            });
        }
    }

    private addValuesToDataIfNotPresent(values: any, data: any, saveAddedPdoIDs: boolean = false): any {
        values.forEach((value) => {
            if (data.filter((d) => { return d.pdoId === value.pdoId; }).length === 0) {
                data.push(value);

                //Wenn Elemente in die dataSource hinzugef�gt wurden, speichern wir ihre PdoIDs,
                //um sie sp�ter ausblenden zu k�nnen, da sie nur f�r die korrekte Anzeige 
                //der ausgew�hlten Elemente im Eingabefeld des Controls ben�tigt werden.
                if (saveAddedPdoIDs) {
                    this.pdoIDsToHide.push(value.pdoId);
                }
            }
        });
        return data;
    }

    private dataBoundHandler(): void {
        if (!this.jQueryControl)
            return;

        const kendoMultiSelect = this.jQueryControl.find('select').data("kendoMultiSelect") as kendo.ui.MultiSelectExt;

        if (!kendoMultiSelect)
            return;

        const items = kendoMultiSelect.ul?.children();

        if (this.pdoIDsToHide.length > 0 && items?.length > 0) {
            items.each((index, item) => {
                const dataItem = kendoMultiSelect.dataItem(item);
                const pdoId = dataItem?.pdoId;

                if (pdoId && this.pdoIDsToHide.includes(pdoId))
                    $(item).hide();
            });

            this.pdoIDsToHide = [];
        }
    }

    private assembleFilter(options: any, pdTypeName: any): any {
        if (!options.data.filter || options.data.filter.filters.length <= 0) {
            return pdTypeName != null ? FilterHelper.createFilterObjectForStaticFilter(this.detailViewItem.listView.staticFilterExpression) : null;
        }
        let filterValue = options.data.filter.filters[0].value;
        if (pdTypeName != null) {
            let staticFilter = this.detailViewItem.listView.staticFilterExpression;
            let searchFields = this.searchFields.split(',');
            let filterObj = {
                staticFilter: staticFilter,
                components: []
            };
            searchFields.forEach((field) => {
                field = field.trim();
                let operator;
                if (this.containsMode === true) {
                    operator = 'LIKE';
                } else {
                    operator = '=';
                }
                let filterTerm = { property: field, value: filterValue, operator: operator };
                filterObj.components.push({ filter: filterTerm, connector: "OR" })
            });
            return filterObj;
        }
    }
    private OnDisconnection(pdoId: any): any {
        let disconnectionHelper = new this.ObjectDisconnectionHelper({
            contextPdoId: this.context.genericObject.pdoId,
            associationName: this.detailViewItem.listView.relationName,
            pdTypeName: this.detailViewItem.listView.typeName,
            affectedObjectIds: pdoId,
            disconnectionCallback: () => {
                this.OnDisconnectionCallback(pdoId);
            },
            confirmDeletionCallback: this.OnConfirmDeletionCallback.bind(this)
        });
        disconnectionHelper.ExecuteCheck();
    }
    private OnDisconnectionCallback(pdoId: any): any {
        $.when(this.context.notifyBeforeUpdatedAssociation(this.detailViewItem.listView.relationName, 'disconnect', { toPdoIds: [pdoId] }))
            .then((doUpdateAssociation) => {
                if (this.isDisposed)
                    return;
                
                if (doUpdateAssociation == null || doUpdateAssociation === true) {
                    Loader.getInstance().show();
                    RADEnvironmentProxy.getInstance().disconnect({
                        pdoID: this.context.genericObject.pdoId,
                        assoziationName: this.detailViewItem.listView.relationName,
                        topdTypeName: this.detailViewItem.listView.typeName,
                        toPDOID: pdoId,
                        nestedContextName: this.context.getNestedContextPath()
                    }).then((changeObject) => {
                        if (this.isDisposed)
                            return;
                        
                        if (this.validateStatus(changeObject)) {
                            this.context.genericObject.isModified(true);
                            this.context.notifyUpdatedAssociation(this.detailViewItem.listView.relationName);
                            this.context.notifyFactoryRefreshed(this.detailViewItem);
                        }
                    }).always(() => {
                        this.viewModel.multiSelectAutoComplete.values.evaluate();
                        Loader.getInstance().hide();
                    });
                }
            });
    }
    private OnConnection(toPDOIDs: any): any {
        if (+this.context.genericObject.pdoId > 0) {
            this.OnConnectionCallback(toPDOIDs);
        } else {
            this.viewModel.multiSelectAutoComplete.values.evaluate();
        }
    }
    private OnConnectionCallback(objectIdsToConnect: any): any {
        let objectIds = Array.isArray(objectIdsToConnect) ? objectIdsToConnect : [objectIdsToConnect];
        $.when(this.context.notifyBeforeUpdatedAssociation(this.detailViewItem.listView.relationName, 'connect', { toPdoIds: objectIds }))
            .then((doUpdateAssociation) => {
                if (this.isDisposed)
                    return;
                
                if (doUpdateAssociation == null || doUpdateAssociation === true) {
                    Loader.getInstance().show();
                    let contextId = this.context.genericObject.pdoId;
                    if (+contextId > 0) {
                        RADEnvironmentProxy.getInstance().connectMany({
                            pdoID: contextId,
                            assoziationName: this.detailViewItem.listView.relationName,
                            topdTypeName: this.detailViewItem.listView.typeName,
                            toPDOIDs: objectIds,
                            nestedContextName: this.context.getNestedContextPath()
                        }).then((changeObject) => {
                            if (this.isDisposed)
                                return;
                            
                            if (this.validateStatus(changeObject)) {
                                this.context.genericObject.isModified(true);
                                this.context.notifyUpdatedAssociation(this.detailViewItem.listView.relationName);
                                this.context.notifyFactoryRefreshed(this.detailViewItem);
                            }
                        }).always(() => {
                            this.viewModel.multiSelectAutoComplete.values.evaluate();
                            Loader.getInstance().hide();
                        });
                    } else {
                        RADEnvironmentProxy.getInstance().getObject({
                            pdTypeName: this.detailViewItem.listView.typeName,
                            pdoID: objectIdsToConnect,
                            properties: ['ObjectIdentValue']
                        }).then((genericDTO) => {
                            if (this.isDisposed)
                                return;
                            
                            this.viewModel.multiSelectAutoComplete.values.evaluate();
                        }).always(() => {
                            Loader.getInstance().hide();
                        });
                    }
                }
            });
    }
    private OnConfirmDeletionCallback(dialogResult: any): any {
        if (dialogResult === true) {
            let associationName = this.detailViewItem.listView.relationName;
            $.when(this.context.notifyBeforeUpdatedAssociation(associationName, 'disconnectAndDelete', { toPdoIds: [this.pdoId()] }))
                .then((doUpdateAssociation) => {
                    if (this.isDisposed)
                        return;
                    
                    if (doUpdateAssociation == null || doUpdateAssociation === true) {
                        Loader.getInstance().show();
                        let pdTypeName = this.detailViewItem.listView.typeName;
                        RADEnvironmentProxy.getInstance().deleteObject({
                            pdTypeName: pdTypeName,
                            pdoID: this.pdoId()
                        }).then((changeObject) => {
                            if (this.isDisposed)
                                return;
                            
                            if (this.validateStatus(changeObject)) {
                                this.context.genericObject.isModified(true);
                                this.context.notifyUpdatedAssociation(associationName);
                                this.context.notifyFactoryRefreshed(this.detailViewItem);
                                this.viewModel.multiSelectAutoComplete.values.evaluate();
                            }
                        }).always(() => {
                            Loader.getInstance().hide();
                        });
                    }
                });
        }
    }
}

ComponentManager.setFactory('AssociationMultiAutocompleteBox', AssociationMultiAutocompleteBoxFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');